import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import BonusHistory from './BonusHistory'
import RemoveBrigadeButton from './RemoveBrigadeButton'
import WtnSelector from './WtnSelector'
import ShowMoreButton from './ShowMoreButton'
import HistoryLinkButton from './HistoryLinkButton'
import useBonusHistory from '../hooks/useBonusHistory'
import { writeProgramHistory } from './utils/profileProgramUtils'

const DeletedBrigade = ({
  bonusesPath,
  dutyCareLink,
  hasBonus,
  hasLastShipment,
  id,
  leaveBrigadePath,
  name,
  shipmentsPath,
  t,
  wtnIds,
  wtnPdfPath,
  years,
}) => {
  const {
    bonuses,
    hasError,
    isLoading,
    isShowingBonusHistory,
    toggleBonusHistory,
  } = useBonusHistory(bonusesPath, t)

  const handleProgramHistoryClick = useCallback(
    (e) => {
      e.preventDefault()
      writeProgramHistory(shipmentsPath)
    },
    [shipmentsPath],
  )

  const renderBonusHistory = () => {
    if (!hasBonus) {
      return null
    }

    return (
      <div>
        <div className="deletedCollection_bonuses">
          <HistoryLinkButton
            className="deletedCollection_historyLink readMoreLink"
            onClick={toggleBonusHistory}
          >
            {t['tcnext.see_bonus_history']}
          </HistoryLinkButton>
        </div>
        {isShowingBonusHistory && (
          <BonusHistory
            bonuses={bonuses}
            hasError={hasError}
            isLoading={isLoading}
            t={t}
          />
        )}
      </div>
    )
  }

  return (
    <div>
      <RemoveBrigadeButton path={leaveBrigadePath} t={t} />
      <div className="deletedCollection_lable mobile inactive">
        <span>{t['tcred.collection.deleted']}</span>
      </div>

      <div className="deletedCollection_mainBlock toggledBody">
        <div className="deletedCollection_lable inactive">
          <span>{t['tcred.collection.deleted']}</span>
        </div>
        <div className="deletedCollection_headline">
          <h5 className="deletedCollection_title">{name}</h5>
        </div>

        <div className="deletedBrigadeCollection_shipments">
          {hasLastShipment && (
            <p className="deletedBrigadeCollection_lastShipment">
              {t['tcnext.profile.received_shipment_with_stats']}
            </p>
          )}
        </div>

        <div className="deletedCollection_buttonWrapper">
          <div />
          <HistoryLinkButton
            className="deletedCollection_historyLink readMoreLink"
            href="#program-activity"
            onClick={handleProgramHistoryClick}
          >
            {t['tcnext.see_shipment_history']}
          </HistoryLinkButton>
        </div>

        {(years || wtnIds) && (
          <WtnSelector
            dutyCareLink={dutyCareLink}
            id={id}
            t={t}
            wtnIds={wtnIds}
            wtnPdfPath={wtnPdfPath}
            years={years}
          />
        )}

        {renderBonusHistory()}
      </div>
      <ShowMoreButton t={t} />
    </div>
  )
}

DeletedBrigade.propTypes = {
  bonusesPath: PropTypes.string.isRequired,
  dutyCareLink: PropTypes.string,
  hasBonus: PropTypes.bool.isRequired,
  hasLastShipment: PropTypes.bool.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  leaveBrigadePath: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  shipmentsPath: PropTypes.string.isRequired,
  t: PropTypes.object.isRequired,
  wtnIds: PropTypes.array,
  wtnPdfPath: PropTypes.string.isRequired,
  years: PropTypes.array,
}

export default DeletedBrigade
